import {createStore} from '@web/helpers/redux'
import {browserEventEmitter} from '@web/middlewares/browserEventEmitter'

import {ResultRootState as RootState} from '../../interfaces'
import {uiEventLoggerMiddleware, uiEventActions} from '../../store/result/middlewares'

import createRootReducer from './reducer'
import SmartstoreResultSentryEnhancer from './sentryEnhancer'

/** 스마트 스토어 주문결과 store */
const store = createStore<RootState>({
    rootReducerCreator: createRootReducer,
    middlewares: [uiEventLoggerMiddleware, browserEventEmitter],
    defaultMiddlewareOptions: {
        serializableCheck: {
            ignoredActions: [...uiEventActions],
        },
    },
    sentryEnhancerOptions: SmartstoreResultSentryEnhancer,
})

export default store
